import React from 'react'
import { Field } from 'redux-form'

export const withValueField = (Component) => (props) => (
  <Field
    name={props.name}
    component={({ input: { value } }) => <Component value={value} {...props} />}
  />
)
